import React from "react";
import get from "lodash/get";
import { object, array, bool, string } from "prop-types";
import assetify from "@quintype/framework/assetify";
import { ResponsiveImage, Link } from "@quintype/components";

import DefaultAuthorImage from "../../../../assets/images/default-author-image.svg";

import "./contributorImage.m.css";

// eslint-disable-next-line react/prop-types
const ContributorImage = ({
  authorDisplayName = "",
  authorObj = {},
  slug = "",
  customStyle = false,
  blurStyle = false,
  widths = [100],
  memberProfilePic = false,
}) => {
  const authorImg = authorObj ? authorObj["avatar-s3-key"] || authorObj["avatar-url"] : null;
  const customWrapperStyle = customStyle ? "contributor-base-wrapper-custom" : "";
  const blurImageStyle = blurStyle ? "contributor-image-blur contributor-image" : "contributor-image";

  let publicAuthor = "no";
  if (get(authorObj, "metadata['Public Author']")) {
    const publicAuthorStatus = get(authorObj, "metadata['Public Author']").split(",");
    publicAuthor = publicAuthorStatus[0] ? publicAuthorStatus[0].toLowerCase() : "no";
  }
  const noAuthorImage = () => {
    return publicAuthor === "yes" ? (
      <Link href={slug}>
        <img
          styleName={blurImageStyle}
          className="contributor-image"
          src={`${assetify(DefaultAuthorImage)}`}
          alt={authorObj.name}
        />
      </Link>
    ) : (
      <img
        styleName={blurImageStyle}
        className="contributor-image"
        src={`${assetify(DefaultAuthorImage)}`}
        alt={authorObj.name}
      />
    );
  };

  const s3AuthorImage = () => {
    return publicAuthor === "yes" ? (
      <Link href={slug}>
        <ResponsiveImage
          slug={authorObj["avatar-s3-key"]}
          metadata={authorObj.metadata || ""}
          defaultWidth={100}
          widths={widths}
          imgParams={{ auto: ["format", "compress"] }}
          styleName={blurImageStyle}
          className="contributor-image"
          alt={authorObj.name}
        />
      </Link>
    ) : (
      <ResponsiveImage
        slug={authorObj["avatar-s3-key"]}
        metadata={authorObj.metadata || ""}
        defaultWidth={100}
        widths={widths}
        imgParams={{ auto: ["format", "compress"] }}
        styleName={blurImageStyle}
        className="contributor-image"
        alt={authorObj.name}
      />
    );
  };

  const avatarAuthorImage = () => {
    return publicAuthor ? (
      <Link href={slug}>
        <img
          styleName={blurImageStyle}
          className="contributor-image"
          src={authorObj["avatar-url"]}
          alt={authorObj.name}
        />
      </Link>
    ) : (
      <img
        styleName={blurImageStyle}
        className="contributor-image"
        src={authorObj["avatar-url"]}
        alt={authorObj.name}
      />
    );
  };

  const imageShow = () => {
    const isShowImage = (!authorDisplayName && authorImg && publicAuthor === "yes") || memberProfilePic;
    return isShowImage ? (authorObj["avatar-s3-key"] ? s3AuthorImage() : avatarAuthorImage()) : noAuthorImage();
  };

  return (
    <div className="contributor-base-wrapper" styleName={customWrapperStyle}>
      {imageShow()}
    </div>
  );
};

ContributorImage.propTypes = {
  authorObj: object,
  widths: array,
  authorDisplayName: string,
  slug: string,
  customStyle: bool,
  blurStyle: bool,
  memberProfilePic: bool,
};

export default ContributorImage;
